import React, { useEffect, useRef, useState } from "react";
import { getFontAwesomeIcon } from "../../../../../../utils";
import { SupplyPortal } from "../../../../..";
import { ToggleProps } from "../../types";

const CustomCellExpansionComponent: React.FC<ToggleProps> = ({
	expanded,
	onExpandCell,
	truncated,
	cellClickAction = () => {},
	showSeeUnitsButton = true,
	setHasCustomCellToggle,
	backgroundColor = "bg-navy-50",
}) => {
	const [hoverRect, setHoverRect] = useState<DOMRect | null>(null);
	const iconRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		setHasCustomCellToggle && setHasCustomCellToggle(true);
		return () => {
			setHasCustomCellToggle && setHasCustomCellToggle(false);
		};
	}, [setHasCustomCellToggle]);

	return (
		<button
			onClick={(e) => {
				e.stopPropagation();
				onExpandCell();
			}}
			className={`text-left relative min-w-full ${backgroundColor}  ${
				showSeeUnitsButton ? "" : ""
			}  `}
		>
			{!expanded && (
				<div className="flex items-center">
					<span className="truncate text-sm">{truncated}…</span>

					{/* wrap icon for hover measurement */}
					{showSeeUnitsButton && (
						<span
							ref={iconRef}
							onMouseEnter={() => {
								if (iconRef.current) {
									setHoverRect(
										iconRef.current.getBoundingClientRect(),
									);
								}
							}}
							onMouseLeave={() => setHoverRect(null)}
							onClick={(e) => {
								e.stopPropagation();
								cellClickAction();
							}}
							className="ml-2 cursor-pointer relative inline-block "
						>
							<span className="text-primary hover:text-supply-blue-300 cursor-pointer">
								{getFontAwesomeIcon("chevronsRight", "regular")}
							</span>

							{hoverRect && (
								<SupplyPortal containerId="portal-root">
									<div
										style={{
											position: "absolute",

											top:
												hoverRect.top +
												window.scrollY +
												hoverRect.height / 2 +
												"px",

											left:
												hoverRect.right +
												window.scrollX +
												8 +
												"px",
											transform: "translateY(-50%)",
										}}
										className="
										bg-navy-400 text-white text-xs
										rounded px-2 py-1 whitespace-nowrap
										pointer-events-none z-[9999]
									"
									>
										See units
									</div>
								</SupplyPortal>
							)}
						</span>
					)}
				</div>
			)}
		</button>
	);
};

export default CustomCellExpansionComponent;
